<template>
  <w-sliding-popup v-loading="isLoading" ref="slidingPopup" :title="popupTitle" :type="type" width="500px" @close="close" @open="open">
    <div slot="content">
      <!-- 기본 정보 -->
      <el-form :model="basicInfoFormData" label-position="top" ref="basicInfoForm" :rules="basicInfoRules">
        <div class="mr-b25">
          <div class="title-h4 title-bar">기본 정보</div>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="이름" prop="credentialName">
                <el-input v-model="basicInfoFormData.credentialName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="방식" prop="credentialMethodId">
                <el-select v-model="basicInfoFormData.credentialMethodId" style="width:100%">
                  <el-option v-for="item in modelingMethodList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="설명" prop="credentialDesc">
              <el-input v-model="basicInfoFormData.credentialDesc"></el-input>
            </el-form-item>
          </el-row>
        </div>
      </el-form>
      <!-- 스캔 방식 정보 -->
      <div v-show="basicInfoFormData.credentialMethodId == 'SCAN'">
        <el-form :model="scanInfoFormData" label-position="top" ref="scanInfoForm">
          <div class="title-h4 title-bar">스캔 방식 설정</div>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="SNMP 버전" prop="version">
                <el-select v-model="scanInfoFormData.version" style="width:100%">
                  <el-option v-for="item in versionList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="SNMP 포트" prop="port">
                <el-input v-model="scanInfoFormData.port"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-show="scanInfoFormData.version != 'V3'">
            <el-col :span="12">
              <el-form-item label="커뮤니티 값" prop="communityRead">
                <el-input type="password" v-model="scanInfoFormData.communityRead"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <div v-show="scanInfoFormData.version == 'V3'">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item label="USER" prop="user">
                  <el-input v-model="scanInfoFormData.user"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Context 명" prop="contextName">
                  <el-input v-model="scanInfoFormData.contextName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Context ID" prop="contextId">
                  <el-input v-model="scanInfoFormData.contextId"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="height:25px">
              <el-col :span="12">
                <span>Auth</span>
              </el-col>
              <el-col :span="12">
                <el-row type="flex" justify="end">
                  <el-switch v-model="scanInfoFormData.authActiveFlag" active-value="1" inactive-value="0"></el-switch>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10" v-show="scanInfoFormData.authActiveFlag == '1'">
              <el-col :span="12">
                <el-form-item label="프로토콜" prop="auth">
                  <el-select v-model="scanInfoFormData.auth" style="width:100%">
                    <el-option v-for="item in snmpAuthList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="비밀번호" prop="authPassword">
                  <el-input type="password" v-model="scanInfoFormData.authPassword"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="height:25px">
              <el-col :span="12">
                <span>Privacy</span>
              </el-col>
              <el-col :span="12">
                <el-row type="flex" justify="end">
                  <el-switch v-model="scanInfoFormData.privActiveFlag" active-value="1" inactive-value="0"></el-switch>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="10" v-show="scanInfoFormData.privActiveFlag == '1'">
              <el-col :span="12">
                <el-form-item label="프로토콜" prop="privacy">
                  <el-select v-model="scanInfoFormData.privacy" style="width:100%">
                    <el-option v-for="item in snmpPrivList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="비밀번호" prop="privacyPassword">
                  <el-input type="password" v-model="scanInfoFormData.privacyPassword"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <!-- 접속 방식 정보 -->
      <div v-show="basicInfoFormData.credentialMethodId != 'SCAN'">
        <el-form :model="accessInfoFormData" label-position="top" ref="accessInfoForm" :rules="accessInfoRules">
          <div class="title-h4 title-bar">접속 방식 설정</div>
          <el-row :gutter="10" class="mr-b15">
            <el-col :span="12">
              <el-form-item label="프로토콜" prop="attrTypeId">
                <el-select v-model="accessInfoFormData.attrTypeId" style="width:100%">
                  <el-option v-for="item in protocolList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="accessInfoFormData.attrTypeId == 'TELNET'">
              <el-form-item label="포트" prop="telnetPort">
                <el-input v-model="accessInfoFormData.telnetPort"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="accessInfoFormData.attrTypeId == 'SSH'">
              <el-form-item label="포트" prop="sshPort">
                <el-input v-model="accessInfoFormData.sshPort"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="tit" style="font-weight:500">1차 로그인 정보</div>
          <el-row class="mr-b15" :gutter="10">
            <el-col :span="12">
              <el-form-item label="계정" prop="loginId">
                <el-input v-model="accessInfoFormData.loginId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="비밀번호" prop="loginPassword">
                <el-input type="password" v-model="accessInfoFormData.loginPassword"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="tit" style="font-weight:500">2차 로그인 정보</div>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="계정" prop="privilegeId">
                <el-input v-model="accessInfoFormData.privilegeId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="비밀번호" prop="privilegePassword">
                <el-input type="password" v-model="accessInfoFormData.privilegePassword"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="로그인 템플릿 선택" prop="templateId">
              <el-select v-model="accessInfoFormData.templateId" style="width:100%">
                <el-option v-for="item in loginTemplateList" :key="item.templateId" :label="item.templateName" :value="item.templateId"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="clickSaveButton">저장</el-button>
      <el-button size="large" @click="clickCancelButton">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isEqual, isNil, cloneDeep, forEach, assign } from 'lodash';
import msgUtil from '@/utils/message';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';
import { PASSWORD_FOR_VIEW } from '@/constants/common';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';

export default {
  name: 'WAddModelingPopup',
  props: {
    selectedBasicInfoFormData: {
      type: Object,
      default: () => ({
        credentialId: null,
        credentialDesc: null,
        credentialMethodId: null,
        credentialName: null,
        credentialTypeId: null,
      }),
    },
    selectedSubFormData: {
      type: Object,
      default: () => ({
        communityRead: null,
      }),
    },
    popupType: {
      type: String,
      default: 'ADD',
    },
    type: {
      type: String,
      default: 'setting',
    },
  },
  data() {
    return {
      isLoading: false,
      popupTitle: '모델링 방식 추가',
      basicInfoFormData: {
        credentialName: null,
        credentialMethodId: 'SCAN',
        credentialDesc: null,
      },
      scanInfoFormData: {
        attrTypeId: 'SNMP',
        version: 'V1/V2',
        port: 161,
        auth: 'MD5',
        privacy: 'DES',
        privacyPassword: null,
        communityRead: null,
        authActiveFlag: 0,
        privActiveFlag: 0,
        user: null,
        contextName: null,
        contextId: null,
        authPassword: null,
      },
      accessInfoFormData: {
        templateId: null,
        attrTypeId: 'TELNET',
        telnetPort: 23,
        sshPort: 22,
        loginId: null,
        loginPassword: null,
        privilegeId: null,
        privilegePassword: null,
      },
      basicInfoRules: {
        credentialName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        credentialDesc: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
      accessInfoRules: {
        loginPassword: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
      modelingMethodList: [],
      versionList: [],
      snmpAuthList: [],
      snmpPrivList: [],
      loginTemplateList: [],
      protocolList: [
        {
          basicinfoSubid: 'TELNET',
          basicinfoSubname: 'TELNET',
        },
        {
          basicinfoSubid: 'SSH',
          basicinfoSubname: 'SSH',
        },
      ],
    };
  },
  methods: {
    loadData() {},
    open() {
      BasicinfoSubAPI.getList('MODELING_METHOD').then((response) => {
        this.modelingMethodList = cloneDeep(response.data.data);
      });
      BasicinfoSubAPI.getList('SNMPVER').then((response) => {
        this.versionList = cloneDeep(response.data.data);
      });
      BasicinfoSubAPI.getList('SNMPAUTH').then((response) => {
        this.snmpAuthList = cloneDeep(response.data.data);
      });
      BasicinfoSubAPI.getList('SNMPPRIV').then((response) => {
        this.snmpPrivList = cloneDeep(response.data.data);
      });
      DeviceRegistrationNmsAPI.getLoginTemplateList().then((response) => {
        this.loginTemplateList = cloneDeep(response.data.data);
        this.$nextTick(() => {
          if (isNil(this.selectedBasicInfoFormData)) {
            this.accessInfoFormData.templateId = this.loginTemplateList[0].templateId;
          } else if (!isNil(this.selectedBasicInfoFormData)) {
            if (isNil(this.selectedBasicInfoFormData.templateId)) {
              this.accessInfoFormData.templateId = this.loginTemplateList[0].templateId;
            }
          }
        });
      });
      const object = this.selectedBasicInfoFormData;
      if (this.popupType === 'UPDATE') {
        this.popupTitle = `${object.credentialName} 정보`;
        this.basicInfoFormData = object;
        if (isEqual(object.credentialMethodId, 'SCAN')) {
          this.selectedSubFormData.attrTypeId = object.credentialTypeId;
          Object.assign(this.scanInfoFormData, this.selectedSubFormData);
          if (!isNil(this.selectedSubFormData.auth)) {
            this.scanInfoFormData.authActiveFlag = '1';
          }
          if (!isNil(this.selectedSubFormData.privacy)) {
            this.scanInfoFormData.privActiveFlag = '1';
          }
        } else {
          this.selectedSubFormData.attrTypeId = object.credentialTypeId;
          this.selectedSubFormData.templateId = object.templateId;
          Object.assign(this.accessInfoFormData, this.selectedSubFormData);
        }
      } else {
        this.popupTitle = '모델링 방식 추가';
        this.basicInfoFormData = {
          credentialMethodId: 'SCAN',
        };
        this.scanInfoFormData = {
          attrTypeId: 'SNMP',
          version: 'V1/V2',
          port: 161,
          auth: 'MD5',
          privacy: 'DES',
          privacyPassword: null,
          communityRead: null,
          authActiveFlag: 0,
          privActiveFlag: 0,
          user: null,
          contextName: null,
          contextId: null,
          authPassword: null,
        };
        this.accessInfoFormData = {
          templateId: null,
          attrTypeId: 'TELNET',
          telnetPort: 23,
          sshPort: 22,
          loginId: null,
          loginPassword: null,
          privilegeId: null,
          privilegePassword: null,
        };
      }
    },
    close() {
      this.$emit('close-popup');
      this.$refs.basicInfoForm.resetFields();
      this.$refs.scanInfoForm.resetFields();
      this.$refs.accessInfoForm.resetFields();
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    clickSaveButton() {
      const checkValidation = [];
      checkValidation.push(
        new Promise((resolve, reject) => {
          this.$refs.basicInfoForm
            .validate()
            .then((res) => {
              resolve(res);
            })
            .catch(() => {
              reject(false);
            });
        }),
      );

      if (this.basicInfoFormData.credentialMethodId !== 'SCAN') {
        checkValidation.push(
          new Promise((resolve, reject) => {
            this.$refs.accessInfoForm
              .validate()
              .then((res) => {
                resolve(res);
              })
              .catch(() => {
                reject(false);
              });
          }),
        );
      }

      Promise.all(checkValidation)
        .then(() => {
          const basicInfoFormData = this.basicInfoFormData;
          const subFormData = isEqual(basicInfoFormData.credentialMethodId, 'SCAN') ? this.scanInfoFormData : this.accessInfoFormData;
          const resultData = Object.assign({}, basicInfoFormData, subFormData);

          // 암호화 처리
          const requireEncryptFields = ['communityRead', 'authPassword', 'privacyPassword', 'loginPassword', 'privilegePassword'];
          const encryptTargetData = createEncryptTargetData(resultData, requireEncryptFields);
          const target = '모델링 방식';
          const action = msgUtil.action.SAVE;
          if (encryptTargetData !== null) {
            getRsaEncrypt(encryptTargetData)
              .then((encryptData) => {
                this.saveModeling(assign(resultData, encryptData), action, target);
              })
              .catch((e) => {
                this.$message(msgUtil.getResultMsgData(action, target, false));
                throw new Error(e);
              });
          } else {
            this.saveModeling(resultData, action, target);
          }
        })
        .catch(() => {
          this.$message(msgUtil.getCustomMsgData('올바른 값을 입력해주시길 바랍니다.'));
        });
    },
    /**
     * 모델링 방식을 저장한다.
     * @author Ju
     * @param  {[type]} resultData [description]
     * @param  {[type]} action     [description]
     * @param  {[type]} target     [description]
     * @return {[type]}            [description]
     */
    saveModeling(resultData, action, target) {
      if (isNil(this.selectedBasicInfoFormData)) {
        this.isLoading = true;
        DeviceRegistrationNmsAPI.insertModelingMethod(resultData)
          .then((response) => {
            const result = response.data;
            if (result.success === true) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.$emit('re-load');
              this.closePopup();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.isLoading = true;
        DeviceRegistrationNmsAPI.updateModelingMethod(resultData)
          .then((response) => {
            const result = response.data;
            if (result.success === true) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.$emit('re-load');
              this.closePopup();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    clickCancelButton() {
      this.closePopup();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/popup/AddModelingPopup.vue